<div class="flex items-center gap-2 whitespace-nowrap">
  <div [style.width]="width()">
    <app-model-field-select
      [id]="testId()"
      [testId]="testId()"
      [options]="importanceScoreOptions()"
      optionLabel="label"
      optionValue="value"
      [placeholder]="placeholder()"
      [value]="selectedValue()"
      (valueChange)="onValueChange($event)"
      [showClear]="!disabled()"
      [disabled]="disabled()"
    />
  </div>
  <div class="w-6 h-6 flex items-center justify-center">
    @if (selectedImportanceScore()) {
      <app-importance-icon
        class="ml-4 shrink-0"
        [importanceScore]="selectedImportanceScore()"
      ></app-importance-icon>
    }
  </div>
</div>
